import { ContentStatus, SimulationCaseList } from "__generated__/types";
import { Button } from "common/buttons";
import { Modal } from "common/components/Modal";
import { NoDataError } from "common/components/NoDataError";
import { Section } from "common/components/Section";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import { SIMULATION_CASE_LIST_QUERY as QUERY } from "domain/common/simulation-mutations";
import React, { useState } from "react";
import styles from "./SimulationAdmin.module.css";

interface Props {
  cancel(): void;
  complete(): void;
  setState(content: any): void;
}

export const AddNextCase: React.FC<Props> = ({ complete, setState }) => {
  const { data, loadingOrError } = useSimpleQuery<SimulationCaseList>(QUERY);
  const [searchQuery, setSearchQuery] = useState("");

  if (loadingOrError) {
    return loadingOrError;
  }

  if (!data) {
    return <NoDataError />;
  }

  return (
    <Section>
      <>
        <input
          type="text"
          placeholder="Søk etter casetittel..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          className={styles.search}
        />
        <div className={styles.caseButtons}>
          {data.simulationCaseList && data.simulationCaseList.length > 0
            ? data.simulationCaseList.map((caseItem, _index) =>
                caseItem.status === ContentStatus.PUBLISHED &&
                caseItem.title
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()) ? (
                  <>
                    <Modal
                      type="inline"
                      kind="tall"
                      title={caseItem.title}
                      buttons={
                        <Button
                          onClick={() => {
                            setState(caseItem.title + " (" + caseItem.id + ")");
                            complete();
                          }}
                          className={styles.completeButton}
                        >
                          Velg
                        </Button>
                      }
                    >
                      <div className={styles.caseContent}>
                        {caseItem.patientInformation
                          ? caseItem.patientInformation.content
                          : ""}
                      </div>
                    </Modal>
                  </>
                ) : (
                  <></>
                ),
              )
            : "Ingen caser tilgjengelig."}
        </div>
      </>
    </Section>
  );
};
